import { PropAsset } from './PropAsset';

// Dead Tree - Ölü Ağaç
// TODO: Replace with SVG asset
export class TreeDead extends PropAsset {
  readonly id = 'tree_dead';
  readonly width = 48;
  readonly height = 88;
  readonly walkable = false;
  readonly collisionRadius = 0.35;
  readonly occludesPlayer = true;

  draw(ctx: CanvasRenderingContext2D, cx: number, cy: number, s: number, _variant?: number): void {
    // Shadow
    ctx.fillStyle = 'rgba(0,0,0,0.15)';
    ctx.beginPath();
    ctx.ellipse(cx, cy - 2 * s, 10 * s, 5 * s, 0, 0, Math.PI * 2);
    ctx.fill();

    // Trunk - Gövde (darker, dead wood)
    ctx.fillStyle = '#3a3030';
    ctx.fillRect(cx - 4 * s, cy - 50 * s, 8 * s, 50 * s);

    // Branches - Dallar
    ctx.strokeStyle = '#3a3030';
    ctx.lineWidth = 3 * s;

    // Left branch
    ctx.beginPath();
    ctx.moveTo(cx - 2 * s, cy - 35 * s);
    ctx.lineTo(cx - 18 * s, cy - 50 * s);
    ctx.stroke();

    // Right branch
    ctx.beginPath();
    ctx.moveTo(cx + 2 * s, cy - 40 * s);
    ctx.lineTo(cx + 15 * s, cy - 55 * s);
    ctx.stroke();

    // Top branches
    ctx.lineWidth = 2 * s;
    ctx.beginPath();
    ctx.moveTo(cx, cy - 50 * s);
    ctx.lineTo(cx - 8 * s, cy - 65 * s);
    ctx.stroke();

    ctx.beginPath();
    ctx.moveTo(cx, cy - 50 * s);
    ctx.lineTo(cx + 6 * s, cy - 62 * s);
    ctx.stroke();

    // Small twigs
    ctx.lineWidth = 1 * s;
    ctx.beginPath();
    ctx.moveTo(cx - 18 * s, cy - 50 * s);
    ctx.lineTo(cx - 22 * s, cy - 58 * s);
    ctx.stroke();
  }
}
